import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { X } from 'lucide-react';

const DEFAULT_DURATION_MS = 5000;

/**
 * Global toaster: 5s duration, dismiss X, and a bottom timer progress line.
 */
export default function AppToaster() {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      toastOptions={{
        duration: DEFAULT_DURATION_MS,
        success: { duration: DEFAULT_DURATION_MS },
        error: { duration: DEFAULT_DURATION_MS },
      }}
    >
      {(t) => {
        const duration =
          typeof t.duration === 'number' && Number.isFinite(t.duration) ? t.duration : DEFAULT_DURATION_MS;
        const showTimer = t.type !== 'loading' && duration > 0 && duration !== Infinity;

        return (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              position: 'relative',
              overflow: 'hidden',
              paddingBottom: showTimer ? 12 : undefined,
            }}
          >
            {({ icon, message }) => (
              <>
                <div className="flex w-full items-start gap-2">
                  {icon}
                  <div className="min-w-0 flex-1">{message}</div>
                  {t.type !== 'loading' && (
                    <button
                      type="button"
                      aria-label="Dismiss notification"
                      onClick={() => toast.dismiss(t.id)}
                      className="-mr-1 -mt-0.5 shrink-0 rounded p-1 text-gray-500 transition-colors hover:bg-black/5 hover:text-gray-800"
                    >
                      <X className="h-3.5 w-3.5" strokeWidth={2.25} />
                    </button>
                  )}
                </div>
                {showTimer && (
                  <div
                    className="pointer-events-none absolute inset-x-0 bottom-0 h-0.5 bg-black/10"
                    aria-hidden
                  >
                    <div
                      className={`h-full origin-left ${
                        t.type === 'error'
                          ? 'bg-red-500/70'
                          : t.type === 'success'
                            ? 'bg-emerald-500/70'
                            : 'bg-gray-500/50'
                      }`}
                      style={{
                        animation: t.visible
                          ? `toast-timer-shrink ${duration}ms linear forwards`
                          : 'none',
                      }}
                    />
                  </div>
                )}
              </>
            )}
          </ToastBar>
        );
      }}
    </Toaster>
  );
}
